import { defineStore } from "pinia";
import { ref } from "vue";

import type { StickerType } from "@/model/StickerType";
import { asReadonly } from "@/utils/vue";

export const useStickerTypeStore = defineStore(
  "stickerType",
  () => {
    const stickerTypes = ref<StickerType[]>([]);

    return {
      stickerTypes: asReadonly(stickerTypes),
      setStickerTypes: (types: StickerType[]) => (stickerTypes.value = types),
    };
  },
  { autoReset: true },
);
